<template>
	<section class="i-emitent">
		<div class="i-emitent__container">
			<div
				v-if="investorsDataIsLoading || investorsData"
				class="i-emitent__component"
			>
				<loader v-if="investorsDataIsLoading" />
				<presentations
					v-if="investorsData?.data.props.presentation"
					:presentations-data="presentations"
					:api-data="investorsData.data.props.presentation"
				/>
				<reporting-and-results
					v-else
					:reporting-and-results-data="presentations"
				/>
			</div>
			<div
				class="i-emitent__component"
				:class="{ large: reportingAndResults.large }"
			>
				<reporting-and-results
					:reporting-and-results-data="reportingAndResults"
				/>
			</div>
			<div
				v-if="investorsDataIsLoading || investorsData"
				class="i-emitent__component"
			>
				<loader v-if="investorsDataIsLoading" />
				<bond-issues
					v-if="investorsData"
					:bond-issues-data="bondIssues"
					:api-data="investorsData.data.props"
				/>
			</div>
			<div class="i-emitent__col">
				<div
					class="i-emitent__component"
					:class="{ small: bondCalculator.small }"
				>
					<reporting-and-results :reporting-and-results-data="bondCalculator" />
				</div>
				<div class="i-emitent__component" :class="{ small: statistic.small }">
					<reporting-and-results :reporting-and-results-data="statistic" />
				</div>
			</div>
			<div class="i-emitent__col">
				<div
					v-if="investorsDataIsLoading || investorsData"
					class="i-emitent__component small"
				>
					<loader v-if="investorsDataIsLoading" />
					<credit-ratings
						v-if="
							investorsData &&
							investorsData.data.props.credit_esg.credit_ratings
						"
						:credit-ratings-data="
							investorsData.data.props.credit_esg.credit_ratings
						"
						small
					/>
				</div>
				<div
					v-if="investorsDataIsLoading || investorsData"
					class="i-emitent__component"
				>
					<loader v-if="investorsDataIsLoading" />
					<esg-ratings
						v-if="investorsData && investorsData.data.props.credit_esg.esg"
						:esg-ratings-data="investorsData.data.props.credit_esg.esg"
					/>
				</div>
			</div>
			<div class="i-emitent__col">
				<div
					class="i-emitent__component"
					:class="{ small: informationDisclosure.small }"
				>
					<reporting-and-results
						:reporting-and-results-data="informationDisclosure"
					/>
				</div>
				<div
					class="i-emitent__component"
					:class="{ small: mortgageBonds.small }"
				>
					<reporting-and-results :reporting-and-results-data="mortgageBonds" />
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import Loader from '../vue-components/Loader'
import ReportingAndResults from './components/ReportingAndResults'
import InvestorCalendar from './components/InvestorCalendar'
import Presentations from './components/Presentations'
import BondIssues from './components/BondIssues'
import CreditRatings from './components/CreditRatings'
import EsgRatings from './components/EsgRatings'
import { investorsDataActionTypes } from '../store/modules/investors/investors'
import { mapState } from 'vuex'

export default {
	name: 'Domrf',
	components: {
		Loader,
		ReportingAndResults,
		InvestorCalendar,
		Presentations,
		BondIssues,
		CreditRatings,
		EsgRatings,
	},
	computed: {
		...mapState({
			investorsDataIsLoading: state => state.investorsData.isLoading,
			investorsData: state => state.investorsData.data,
			investorsDataError: state => state.investorsData.error,
		}),
	},
	methods: {
		getDateNow() {
			const options = {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
			}
			const timeElapsed = Date.now()
			return new Date(timeElapsed).toLocaleString('ru', options)
		},
	},
	data() {
		return {
			apiUrl: '/api/v2/content/investors/ipotechnye-obligacii/',
			reportingAndResults: {
				picture: {
					src: '/static/v2/src/img/investors/ia/reporting-and-results',
					name: 'Аналитика и обзор рынка',
					width: '288',
					height: '252',
				},
				header: 'Аналитика и обзор рынка',
				desc: 'Основные показатели рынка ипотечных облигаций',
				link: 'https://xn--90an6b.xn--d1aqf.xn--p1ai/media/analytics/2023/',
			},
			bondCalculator: {
				small: true,
				labelBgColor: '#D6CDC7',
				picture: {
					src: '/static/v2/src/img/investors/ia/bond-caLculator',
					name: 'Калькулятор облигаций',
					width: '288',
					height: '252',
				},
				header: 'Калькулятор облигаций',
				desc: 'Сделайте расчет на сайте калькулятор.дом.рф',
				link: ' https://xn--80atbdbsooh2gqb.xn--d1aqf.xn--p1ai/instruments/convention2/',
			},
			statistic: {
				small: true,
				labelBgColor: '#9AC2FF',
				header: 'Статистика ипотечных покрытий',
				desc: 'Инструменты. Статистика ипотечных покрытий ИЦБ\u00A0ДОМ.РФ',
				link: 'https://xn--80atbdbsooh2gqb.xn--d1aqf.xn--p1ai/instruments/pools/statistics?date=2023-11-27&showredeemed=false',
			},
			presentations: {
				labelBgColor: '#A3D562',
				picture: {
					src: '/static/v2/src/img/investors/sopf/presentation',
					name: 'Презентации',
					width: '288',
					height: '252',
				},
				header: 'Презентации',
				desc: 'Страница находится в разработке',
			},
			bondIssues: {
				header: 'Выпуски облигаций',
				image: '/static/v2/src/img/investors/icons/graph.png',
				issues: {
					name: 'Количество выпусков',
				},
				sum: {
					name: 'Объем выпусков',
				},
				date: 'В обращении',
				link: 'https://xn--90an6b.xn--d1aqf.xn--p1ai/bonds/issues/',
			},
			creditRatings: {
				small: true,
				header: 'Кредитный рейтинги поручителя',
				creditRatings: {
					tooltip:
						'С 2016 г. осуществляется выпуск стандартизированных ипотечных облигаций, обеспеченных поручительством ДОМ.РФ',
					items: [
						{
							icon: {
								src: '/static/v2/src/img/investors/icons/akra.svg',
								name: 'Akra',
								width: '164',
								height: '24',
							},
							value: 'ААА(RU)',
							press: {
								text: 'Пресс-релиз',
								link: 'https://www.acra-ratings.ru/press-releases/4114/',
							},
						},
						{
							icon: {
								src: '/static/v2/src/img/investors/icons/expert.svg',
								name: 'Expert',
								width: '110',
								height: '24',
							},
							value: 'ruAAA',
							press: {
								text: 'Пресс-релиз',
								link: 'https://raexpert.ru/releases/2023/jul07b',
							},
						},
					],
				},
			},
			esgRatings: {
				title: 'ESG',
				items: [
					{
						icon: {
							src: '/static/v2/src/img/investors/icons/akra-black.svg',
							name: 'Akra',
							width: '164',
							height: '24',
						},
						value: 'Соответствие принципам облигаций устойчивого развития',
						press: 'https://www.acra-ratings.ru/ratings/issuers/519/',
					},
					{
						icon: {
							src: '/static/v2/src/img/investors/icons/expert-black.svg',
							name: 'Expert',
							width: '110',
							height: '24',
						},
						value: 'Соответствие принципам социальных и зеленых облигаций',
						press: 'https://raexpert.ru/database/companies/1000043190/',
					},
				],
			},
			informationDisclosure: {
				small: true,
				labelBgColor: '#E3EEFF',
				header: 'Раскрытие информации',
				link: 'https://www.e-disclosure.ru/portal/company.aspx?id=36731&attempt=1',
				picture: {
					src: '/static/v2/src/img/investors/domrf/information-disclosure',
					name: 'Раскрытие информации',
					width: '256',
					height: '208',
				},
			},
			mortgageBonds: {
				small: true,
				labelBgColor: '#D6CDC7',
				header: 'Ипотечные облигации с поручительством ДОМ.РФ',
				desc: 'Подробнее на сайте «ИЦБ\u00A0ДОМ.РФ»',
				link: 'https://xn--90an6b.xn--d1aqf.xn--p1ai/',
			},
		}
	},
	beforeMount() {
		this.$store.dispatch(investorsDataActionTypes.getInvestorsData, {
			apiUrl: this.apiUrl,
		})
	},
}
</script>
